import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { DepositService } from './deposit.service';

@Injectable({
    providedIn: 'root',
})
export class CcDepositSubmitService {
    constructor(
        private http: HttpClient,
        private depositService: DepositService,
    ) {}

    submitCCDeposit(cvv2: any, paymentAccountUpdateUrl: any, pgwEnabled: any, callback: any, cardToken?: any) {
        let requestData;
        if (pgwEnabled === 'true') {
            requestData = { cvv: cvv2 };
        } else {
            requestData = {
                type: 1,
                cardVerificationCode: cvv2,
                reason: 'cvv update',
            };
        }

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        if (cardToken != null) {
            headers = headers.append('token', cardToken);
        }
        const httpHeaders = {
            headers: headers,
            observe: 'response' as 'body',
        };

        this.http
            .post(paymentAccountUpdateUrl, requestData, httpHeaders)
            .pipe(
                map(
                    (data) => {
                        if (data) {
                            this.depositService.submitDeposit();
                        }
                    },
                    (error: any) => {
                        callback(error);
                    },
                ),
            )
            .subscribe();
    }
}
